import { AutomatedBreakDataInTimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';
import { AutomatedBreakType } from '@sdk/settings/types';
import { AutomatedBreakPaidCategory } from '@sdk/automatedBreaks/types/AutomatedBreakPaidCategory';
import { AutomatedBreaksSettingsUI } from '@sdk/automatedBreaks/types/AutomatedBreaksSettingsUI';

import getAutomatedBreaksSettingsForEntry from '@web/timesheets/CreateTimesheetModal/utils/getAutomatedBreaksSettingsForEntry';

const getAutomatedBreaksSettingsBreakForEntry = (
  automatedBreaks: AutomatedBreaksSettingsUI,
  breakType: AutomatedBreakType
): AutomatedBreakDataInTimesheetEntry => ({
  automatedBreakSettingIsPaid:
    automatedBreaks[breakType].isPaid === AutomatedBreakPaidCategory.paid,
  automatedBreakSettingDuration: automatedBreaks[breakType].breakDuration,
  automatedBreakSettingIsEarlyReturn: automatedBreaks[breakType].isEarlyReturn,
  ...getAutomatedBreaksSettingsForEntry(automatedBreaks),
});

export default getAutomatedBreaksSettingsBreakForEntry;
